module.exports = __webpack_public_path__ + "public/img/hua.a380a645.png";